import { type Control, Controller } from 'react-hook-form';
import { useTheme } from 'src/provider/ThemeProvider';
import { clsx } from 'clsx';
import Input from 'src/components/Input/Input';
import type { ProjectSettingsFormValues } from 'src/pages/ControlDeskPage/ProjectControls/ProjectSettingsModal/ProjectSettingFields';

export const ChangeNameField = ({ control }: { control: Control<ProjectSettingsFormValues> }) => {
  const { config } = useTheme();

  return (
    <div className="content">
      <Controller
        control={control}
        name="projectName"
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <Input
            type={'text'}
            label={'Project name'}
            placeholder={'Acme AI Agent'}
            labelClassName={clsx(config?.textColorClassName, 'font-bold text-sm')}
            inputBlockClassName={'mt-1'}
            className="!py-2.5 !px-3.5"
            invalidMessage={error?.message}
            value={value}
            isValid={!error?.message}
            onChange={onChange}
          />
        )}
      />
    </div>
  );
};
